module.exports = {
  changeChargeNo: 'Change Charge No',
  changeReason: 'Change Reason',
  state: 'State',
  jobNo: 'Job No',
  customerId: 'Customer',
  receivable: '売掛',
  dateCreated: 'Create Date',
  createdBy: 'Created By',
  judgeDutyResult: 'Judge Duty Result',
  judgeDutyDate: 'Judge Duty Date',
  judgeDutyBy: 'Judge Duty By',
  businessAuditResult: 'Business Audit Result',
  businessAuditReason: 'Business Audit Reason',
  businessAuditDate: 'Business Audit Date',
  businessAuditBy: 'Business Audit By',
  judgeClosedResult: 'Judge Closed Result',
  judgeClosedDate: 'Judge Closed Date',
  judgeClosedBy: 'Judge Closed By',
  returnReason: 'Return Reason',
  returnDate: 'Return Date',
  returnBy: 'Return By',
  remarks: '備考',
  details: 'Details',
  revoke: 'Revoke',
  return: 'Return',
  judgeDuty: 'Judge Duty',
  businessAudit: 'Business Audit',
  judgeClosed: 'Judge Closed',
  exportDetail: 'Export Detail',
  tabJudgeDuty: 'Await Judge Duty',
  tabBusinessAudit: 'Await Business Audit',
  tabManagerReview: 'Await Manager Review',
  tabJudgeClosed: 'Await Judge Closed',
  tabAll: 'All',
  dateCreatedDay: 'Create Date',
  judgeDutyDateDay: 'Judge Duty Date',
  businessAuditDateDay: 'Business Audit Date',
  judgeClosedDateDay: 'Judge Closed Date',
  applyChangeCharge: 'Apply ChangeCharge',
  applyAddCharge: 'Apply AddCharge',
  applyDeleteCharge: 'Apply DeleteCharge',
  showApplyChangingCharge: 'Review the change fee review',
  ChangeTheChargesInTheExpenseReview: 'Change the charges in the expense review',
  actionType: 'Action Type',
  confirmApplyDeleteCharge: 'Are you sure to apply to delete this fee?',
  changeReasonCannotBeNull: 'Change Reason cannot be null.',
  changeReasonIsTooLong: 'Change Reason the length cannot exceed 100.',
  judgeDutyMessage: 'Is the operator responsible for this change?',
  judgeDutyYes: 'Yes',
  judgeDutyNo: 'No',
  businessAuditMessage: 'Do you agree to change the fee?',
  businessAuditAgree: 'Agree',
  businessAuditRefuse: 'Refuse',
  businessAuditReasonNotNull: 'Please enter refuse reason',
  judgeClosedMessage: 'This change expense is before or after account closing?',
  judgeClosedBefore: 'Before',
  judgeClosedAfter: 'After',
  returnMessage: 'This application will return to its initial state',
  returnMessageConfirm: 'Confirm return?',
  returnReasonNotNull: 'Please enter return reason',
  revokeMessage: 'Only Unapproved Applications can be revoked',
  revokeMessageConfirm: 'Are you sure to cancel the application?',
  modifyBefore: 'Modify Before',
  modifyAfter: 'Modify After',
  estimateProfit: 'Estimate Profit:',
  generateByContract: 'Create by Contract',
  generateByContractConfirm: 'Are you sure to create by Contract?',
  JudgmentResult: 'Judgment result',
  ChangeCharge: 'Change charge',
  OnlyRejectedApplicationFormsCanBeCopied: 'Only rejected application forms can be copied',
  JudgeBeforeAndAfterAccountClosing: 'Judge before and after account closing',
  FeesIncurred: 'Fees incurred',
  updateSuccess: '【{0}】Successfully updated exchange rate for corresponding unoperated expenses',
  exchangeRates: 'Is the expense exchange rate updated due to changes in the exchange rate range?',
  exchangeRates2: 'Is there a change in the exchange rate range of the main invoice? Are you sure to update the expense exchange rate under the main invoice?',
  chargeLanguage: 'Local Description',
  costDescription: 'Cost Description'
}
